import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const RecyclingSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default RecyclingSVG;
